import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const AddCircleLiner24 = () => /*#__PURE__*/_jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/*#__PURE__*/_jsx("path", {
    d: "M7.25 12C7.25 11.5858 7.58579 11.25 8 11.25H11.25V8C11.25 7.58579 11.5858 7.25 12 7.25C12.4142 7.25 12.75 7.58579 12.75 8V11.25H16C16.4142 11.25 16.75 11.5858 16.75 12C16.75 12.4142 16.4142 12.75 16 12.75H12.75V16C12.75 16.4142 12.4142 16.75 12 16.75C11.5858 16.75 11.25 16.4142 11.25 16V12.75H8C7.58579 12.75 7.25 12.4142 7.25 12Z",
    fill: "currentColor"
  }), /*#__PURE__*/_jsx("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M23.5 12C23.5 18.3284 18.3284 23.5 12 23.5C5.67157 23.5 0.5 18.3284 0.5 12C0.5 5.67157 5.67157 0.5 12 0.5C18.3284 0.5 23.5 5.67157 23.5 12ZM22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12Z",
    fill: "currentColor"
  })]
});